import { useState } from "react";
import WebLayout from "../layout/WebLayout";
import { useDispatch, useSelector } from "react-redux";
import { useStates } from "../hooks/useStates";
import { useCities } from "../hooks/useCities";
import { useCategoryFetch } from "../hooks/useCategoryFetch";
import { toastMessage } from "../utils/Message";
import * as authActions from "../store/action/auth";
import { Link } from "react-router-dom";
import WelcomeMessage from "../components/WelcomeMessage";

function MSMERegistration() {
  const dispatch = useDispatch();

  const [categoryType, setCategoryType] = useState("");
  const [entityType, setEntityType] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [entityName, setEntityName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");

  const [message, setMessage] = useState({
    display: false,
    email: "",
    password: "",
  });

  const handelSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        authActions.msmeRegistration(
          categoryType,
          entityType,
          companyName,
          entityName,
          email,
          mobile,
          state,
          district
        )
      );
      if (response.status) {
        toastMessage(response.msg, "success", "top-center", 2000);
        setMessage({
          display: true,
          email: response.data.username,
          password: mobile,
        });
        resetForm();
      } else {
        toastMessage(response.msg, "danger", "top-center", 2000);
      }
    } catch (error) {
      toastMessage(error.message, "danger", "top-center", 2000);
    }
  };

  const resetForm = () => {
    setCategoryType("");
    setEntityType("");
    setCompanyName("");
    setEntityName("");
    setEmail("");
    setMobile("");
    setState("");
    setDistrict("");
  };

  const { categories } = useSelector((state) => state.category);
  const { stateList, city } = useSelector((state) => state.menu);
  useCategoryFetch();
  useStates();
  useCities(state);

  return (
    <WebLayout pageName={"MSMERegistration"}>
      <section className="contact py-20 overflow-hidden">
        <div className="container container-lg">
          {message.display ? (
            <div className="row gy-4">
              <WelcomeMessage
                username={message.email}
                password={message.password}
              />
            </div>
          ) : (
            <div className="row gy-4">
              <div className="col-lg-7">
                <div className="content-scroll">
                  <h5 className="text-md bg-main-600 text-white p-10">
                    Introduction
                  </h5>
                  <p>
                    IndianMSME.org is a pioneering platform designed exclusively
                    for MSME manufacturers including all category other
                    manufacturers to bridge the gap between production and
                    market demand. By leveraging digital and physical channels,
                    we empower manufacturers to focus solely on production while
                    we handle sales, logistics, marketing, and payments.
                  </p>
                  <h5 className="text-md bg-main-600 text-white p-10">
                    Key Features & Benefits
                  </h5>
                  <ul className=" mx-10">
                    <li className="text-gray-600">
                      1. Direct Market Access:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Seamlessly connect with B2B buyers across India.
                        </li>
                        <li>
                          Showcase products through a robust sales platform with
                          nationwide reach.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      2. Door-to-Door Logistics:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Efficient delivery from your manufacturing unit to the
                          buyer's location.
                        </li>
                        <li>
                          Hassle-free logistics management to ensure timely
                          fulfillment.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      3. Payment Assurance:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Buyer payments are managed entirely by IndianMSME.org.
                        </li>
                        <li>
                          Secure transactions with guaranteed settlements.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      4. Display & Retail Presence:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Product display support in Ardh Sainik Mall (DDC) and
                          Ardh Sainik Canteen (Super Stores).
                        </li>
                        <li>
                          Dedicated product racks in 800 planned malls—one in
                          each district.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      5. Digital Marketing Support:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Enhance visibility through tailored digital marketing
                          strategies.
                        </li>
                        <li>
                          Maximize online outreach and attract potential buyers
                          effectively.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      6. Sales Team Assistance:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          A specialized sales force, Abhhyam Marketing Advisors,
                          will actively secure B2B orders for your products.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-600">
                      7. Focus on Production
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Leave logistics, marketing, and sales to us while you
                          focus on creating quality products.
                        </li>
                        <li>
                          A unique, end-to-end B2B platform ensuring your
                          products reach every district in India.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <h5 className="text-md bg-main-600 text-white p-10 mt-10 mb-10">
                    Steps to Join IndianMSME.org
                  </h5>
                  <ul>
                    <li>
                      1. Product Registration:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Submit your product details, including specifications,
                          pricing, and stock availability.
                        </li>
                      </ul>
                    </li>
                    <li>
                      2. Display Setup:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Choose your preferred district for product display in
                          Ardh Sainik Mall (DDC).
                        </li>
                      </ul>
                    </li>
                    <li>
                      3. Digital Marketing Enrolments:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Opt for personalized marketing support to enhance your
                          product’s reach.
                        </li>
                      </ul>
                    </li>
                    <li>
                      4. Logistics & Delivery:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          o Coordinate with our team for seamless stock pick-up
                          and delivery.
                        </li>
                      </ul>
                    </li>
                    <li>
                      5. Sales Activation:
                      <ul className="list-inside mt-10 mb-10 ms-16">
                        <li>
                          Begin receiving online B2B orders facilitated by our
                          platform and sales team.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <h5 className="text-md bg-main-600 text-white p-10 mt-10 mb-10">
                    Why Choose IndianMSME.org?
                  </h5>
                  <ul className="list-inside mt-10 mb-10 ms-16">
                    <li>
                      Nationwide Network: Connect with buyers from every corner
                      of India.
                    </li>
                    <li>
                      Exclusive Retail Opportunity: Showcase your products in
                      800 district-level malls/stores.
                    </li>
                    <li>
                      Marketing Expertise: Gain visibility through professional
                      digital marketing campaigns.
                    </li>
                    <li>
                      Operational Ease: Simplify operations with our
                      comprehensive logistics and payment solutions.
                    </li>
                    <li>
                      Trusted Partnership: Work with a reliable partner
                      committed to MSME growth.
                    </li>
                  </ul>
                  <h5 className="text-md bg-main-600 text-white p-10 mt-10 mb-10">
                    Contact Us
                  </h5>
                  <p>
                    <b>IndianMSME.org</b>
                  </p>
                  <em>(A Concept of ASC Distributor Private Limited)</em>
                  <ul className="list-inside mt-10 mb-10 ms-16">
                    <li>
                      <b>Website:</b>{" "}
                      <a href="https://indianmsme.org/">www.indianmsme.org</a>
                    </li>
                    <li>
                      <b>Email:</b> help@indianmsme.org
                    </li>
                    <li>
                      <b>Phone:</b> +91-88 0000 1242
                    </li>
                  </ul>
                  <p>Join us today and take your business to new heights!</p>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  className="contact-box border border-gray-100 rounded-16 px-20 py-10"
                  style={{ backgroundColor: "#ecfff5" }}>
                  <form onSubmit={handelSubmit} method="post" id="ddcRegForm">
                    <h6 className="mb-5">Manufacturer Registration</h6>
                    <h6 className="mb-2 text-md text-gray-800">
                      केवल निर्माता विक्रेता पंजीकरण
                    </h6>
                    <h6 className="mb-5 text-md text-gray-800">
                      Manufacturer Seller registration only
                    </h6>
                    <div className="row gy-2 mt-5">
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="state"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Category
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <select
                          required
                          className="common-input px-10"
                          value={categoryType}
                          onChange={(e) => setCategoryType(e.target.value)}>
                          <option value="" disabled selected>
                            Select Category
                          </option>
                          {categories &&
                            categories.map((cat, index) => (
                              <option key={index} value={cat.id}>
                                {cat.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="state"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Company Type
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <select
                          className="common-input px-10"
                          name="typeOfCompany"
                          autoComplete="off"
                          onChange={(e) => setEntityType(e.target.value)}
                          required="">
                          <option value="" disabled selected>
                            Select Company Type
                          </option>
                          <option value="Company">Company</option>
                          <option value="LLP">LLP</option>
                          <option value="Proprietorship Firm">
                            Proprietorship Firm
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="name"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Company Name
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <input
                          required
                          type="text"
                          className="common-input px-10"
                          id="name"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                          placeholder="Enter your company name"
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="name"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Authorized Rep Name
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <input
                          required
                          type="text"
                          className="common-input px-10"
                          id="name"
                          value={entityName}
                          onChange={(e) => setEntityName(e.target.value)}
                          placeholder="Enter your authorized rep name"
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="email"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Email
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <input
                          required
                          type="email"
                          className="common-input px-10"
                          id="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter your email"
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="mobile"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          Mobile Number
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <input
                          required
                          type="text"
                          className="common-input px-10"
                          id="mobile"
                          value={mobile}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                            setMobile(value);
                          }}
                          placeholder="Enter your mobile number"
                          maxLength={10}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="state"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          State
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <select
                          required
                          className="common-input px-10"
                          value={state}
                          onChange={(e) => setState(e.target.value)}>
                          <option value="" disabled selected>
                            Select State
                          </option>
                          {stateList.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-sm-6 col-xs-6">
                        <label
                          htmlFor="district"
                          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                          District
                          <span className="text-danger text-xl line-height-1">
                            *
                          </span>
                        </label>
                        <select
                          required
                          className="common-input px-10"
                          value={district}
                          onChange={(e) => setDistrict(e.target.value)}>
                          <option value="" disabled selected>
                            Select District
                          </option>
                          {city.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-12">
                        <div
                          className="form-check text-md"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop">
                          <input
                            className="form-check-input"
                            style={{ border: "1px solid #828282" }}
                            type="checkbox"
                            value=""
                            required
                          />
                          <label className="form-check-label">
                            I agree to the{" "}
                            <Link to="#">Terms and Conditions</Link>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 mt-10">
                        <button
                          type="submit"
                          className="btn btn-main py-18 px-32 rounded-8">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div
            className="modal-content"
            style={{ maxWidth: "100%", width: "100%" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Terms and Conditions
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <h6 className="text-md mb-10">1. Eligibility Criteria</h6>
              <ol className="alpha_list">
                <li>
                  Only Manufacturers including Micro, Small, and Medium
                  Enterprises (MSMEs) as defined under the Government of India's
                  MSME Act are eligible to register.
                </li>
                <li>
                  The registrant must be a manufacturer, not a reseller or
                  trader.
                </li>
                <li>
                  The enterprise must hold a valid Udyam Registration
                  Certificate.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">2. Registration Process</h6>
              <ol className="alpha_list">
                <li>
                  Applicants must provide accurate and up-to-date information,
                  including:
                  <ul>
                    <li>• Udyam Registration Number</li>
                    <li>• GSTIN</li>
                    <li>• PAN Card</li>
                    <li>• Business registration documents</li>
                    <li>• Proof of manufacturing facility (if required)</li>
                  </ul>
                </li>
                <li>
                  The platform reserves the right to verify the information and
                  request additional documents before approval.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                3. Order Handling, Billing, and Pricing
              </h6>
              <ol className="alpha_list">
                <li>
                  All B2B orders will be booked by IndianMSME.org directly from
                  B2B buyers on behalf of the registered MSME manufacturers.
                </li>
                <li>
                  IndianMSME.org will issue invoices to buyers and collect
                  payments for these orders.
                </li>
                <li>
                  MSME manufacturers must quote ex-factory prices only while
                  listing products on the platform.
                </li>
                <li>
                  IndianMSME.org will arrange for the pickup of demanded stock
                  from the MSME manufacturer's location
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                4. Delivery Responsibility
              </h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org will be arrange for delivering the products to
                  the buyers through:
                  <ul>
                    <li>
                      • District Distribution Centres (DDCs) if available, or
                    </li>
                    <li>
                      • Direct delivery from the manufacturer's location to the
                      buyer's address.
                    </li>
                  </ul>
                </li>
                <li>
                  Manufacturers must ensure that products are ready for pickup
                  at the agreed time and location to avoid delays.
                </li>
                <li>
                  Seller will bear responsibility for transportation or
                  delivery.
                </li>
                <li>
                  Seller must ensure that products can reach on define timeline,
                  quality standard, place and avoid delays.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                5. Product Listing and Fulfillment
              </h6>
              <ol className="alpha_list">
                <li>
                  Registered manufacturers must provide detailed product
                  descriptions, accurate pricing, and applicable specifications
                  for listing on the platform.
                </li>
                <li>
                  Manufacturers are responsible for ensuring the quality and
                  packaging of products before they are handed over for
                  delivery.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">6. Prohibited Activities</h6>
              <ol className="alpha_list">
                <li>
                  Misrepresentation of products, including false claims about
                  quality, origin, or certifications, is strictly prohibited.
                </li>
                <li>
                  Listing counterfeit or prohibited items as per Indian laws is
                  not allowed.
                </li>
                <li>
                  Using the platform for fraudulent activities or violating any
                  third-party rights will result in account termination.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                7. Platform Fees and Charges
              </h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org may charge a commission or service fee for
                  facilitating orders and handling delivery. These fees will be
                  disclosed during registration.
                </li>
                <li>
                  All applicable charges will be deducted from the payments
                  collected from buyers before disbursing funds to the
                  manufacturer.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">8. Liabilities</h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org acts as a facilitator between buyers and MSME
                  manufacturers. It is not liable for disputes arising directly
                  between these parties, though it may assist in resolving them
                  at its discretion.
                </li>
                <li>
                  Manufacturers remain solely responsible for the quality of
                  their products.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">9. Data Usage and Privacy</h6>
              <ol className="alpha_list">
                <li>
                  Manufacturers agree to IndianMSME.org using their business
                  information for marketing, analytics, and operational
                  purposes, as per the platform's Privacy Policy.
                </li>
                <li>
                  Sensitive information will be protected and not shared with
                  unauthorized third parties.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">10. Indemnity</h6>
              <p>
                Manufacturers agree to indemnify and hold IndianMSME.org
                harmless against any claims, damages, or legal proceedings
                arising out of their products, delivery issues, or violations of
                these terms.
              </p>
              <h6 className="text-md mt-10 mb-10">11. Termination</h6>
              <ol className="alpha_list">
                <li>
                  Manufacturers may terminate their registration by providing a
                  written request, subject to the settlement of any outstanding
                  dues or obligations.
                </li>
                <li>
                  IndianMSME.org reserves the right to terminate accounts for
                  breach of terms, non-compliance, or inactivity.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">12. Dispute Resolution</h6>
              <p>
                Any disputes will be subject to arbitration under Indian laws,
                with the venue in [City], India.
              </p>
              <h6 className="text-md mt-10 mb-10">13. Amendments</h6>
              <p>
                IndianMSME.org reserves the right to amend these terms at its
                discretion. Manufacturers will be notified of significant
                changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default MSMERegistration;
